import { Inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {
  ENV,
  NYDUS_NETWORK_API_BASE_URL,
  TENANT_NAME,
} from '@rd/core/tokens/rd-lib.token';
import { LeaveConfirmationDialogComponent } from '@rd/popup/components/leave-confirmation-dialog/leave-confirmation-dialog.component';
import { DialogService } from '@rd/popup/services/dialog/dialog.service';
import { EnvironmentType } from 'global-types';

@Injectable({
  providedIn: 'root',
})
export class WestpacRedirectService {
  constructor(
    @Inject(ENV) protected env: EnvironmentType,
    @Inject(NYDUS_NETWORK_API_BASE_URL)
    protected nydusNetworkApiBaseUrl: string,
    @Inject(TENANT_NAME) protected tenantName: string,
    private dialogService: DialogService,
    private translateService: TranslateService,
  ) {}

  redirectDining(): void {
    this.dialogService.open(LeaveConfirmationDialogComponent, {
      data: {
        okClick: () => window.open(this.diningRedirectUrl(), '_blank'),
        title: this.translateService.instant(
          'wl.westpac.dining_redirect.title',
        ),
        description: this.translateService.instant(
          'wl.westpac.dining_redirect.description',
        ),
      },
      id: 'offer-leave-confirmation-dialog',
      screenMode: 'center-md',
      ariaLabel: this.translateService.instant(
        'wl.westpac.dining_redirect.title',
      ),
    });
  }

  diningRedirectUrl(): string {
    let tenantDiningOfferId = '';

    if (this.env === 'production') {
      switch (this.tenantName) {
        case 'bsa':
          tenantDiningOfferId = 'aa6a4b40-20d3-43e9-9f42-b08589352e12';
          break;
        case 'stg':
          tenantDiningOfferId = 'e8e56c0a-c5c6-4322-8d49-9d1299b3e59d';
          break;
        case 'bom':
          tenantDiningOfferId = '7adba393-2ba2-4ff0-8da9-855abaf9b7a0';
          break;
      }
    } else {
      switch (this.tenantName) {
        case 'bsa':
          tenantDiningOfferId = '28358650-c511-4ebe-833b-434a068a3ad5';
          break;
        case 'stg':
          tenantDiningOfferId = '4bf0256b-4bf5-490f-bd66-197c142c3b73';
          break;
        case 'bom':
          tenantDiningOfferId = '6645ff28-6210-4322-a7db-041e5cf2f142';
          break;
      }
    }

    return `${this.nydusNetworkApiBaseUrl}/offers/${tenantDiningOfferId}/redirect?fid=offers:tiles:dining`;
  }
}
